import type React from 'react'
import styled from 'styled-components'

import {Text, __alphaTokens as tokens} from '@pleo-io/telescope'

export type BadgeVariant = 'pink' | 'grey' | 'green' | 'purple' | 'yellow'

export type BadgeProps = {
    children: React.ReactNode
    variant?: BadgeVariant
    as?: keyof JSX.IntrinsicElements | React.ComponentType<any>
    'data-testid'?: string
}

type VariantProps = {
    textColor: string
    backgroundColor: string
}

const variantsProps: Record<BadgeVariant, VariantProps> = {
    green: {
        textColor: tokens.colorContentStatic,
        backgroundColor: tokens.colorBackgroundPresentationalGreen,
    },
    grey: {
        textColor: tokens.colorContentStatic,
        backgroundColor: tokens.colorBackgroundPresentationalGray,
    },
    pink: {
        textColor: tokens.colorContentStatic,
        backgroundColor: tokens.colorBackgroundPresentationalPink,
    },
    purple: {
        textColor: tokens.colorContentStatic,
        backgroundColor: tokens.colorBackgroundPresentationalPurple,
    },
    yellow: {
        textColor: tokens.colorContentStatic,
        backgroundColor: tokens.colorBackgroundPresentationalYellow,
    },
}

const Badge = ({children, variant = 'grey', 'data-testid': dataTestId, as = 'div'}: BadgeProps) => (
    <StyledBadge
        {...variantsProps[variant]}
        as={as}
        data-testid={dataTestId}
        data-generic-ui="badge"
    >
        {children}
    </StyledBadge>
)

const StyledBadge = styled(Text).attrs({
    variant: 'small-subtle',
})<VariantProps>`
    background-color: ${({backgroundColor}) => backgroundColor};
    color: ${({textColor}) => textColor};
    padding: 0px ${tokens.spacing6};
    border-radius: ${tokens.arc4};
`

export default Badge
